import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M.32 5.446c0-.666.54-1.206 1.207-1.206h28.947a1.206 1.206 0 1 1 0 2.413H1.526C.86 6.653.32 6.113.32 5.446Zm0 8.444a2.412 2.412 0 0 1 2.413-2.413h26.535a2.412 2.412 0 1 1 0 4.825H2.733A2.412 2.412 0 0 1 .32 13.89Zm31.36 10.855a3.015 3.015 0 0 0-3.015-3.015H3.335a3.015 3.015 0 1 0 0 6.03h25.33a3.015 3.015 0 0 0 3.015-3.015Z",
		fill: "#262626",
		fillRule: "evenodd",
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2032%2032%22%3E%3Cpath%20d%3D%22M.32%205.446c0-.666.54-1.206%201.207-1.206h28.947a1.206%201.206%200%201%201%200%202.413H1.526C.86%206.653.32%206.113.32%205.446Zm0%208.444a2.412%202.412%200%200%201%202.413-2.413h26.535a2.412%202.412%200%201%201%200%204.825H2.733A2.412%202.412%200%200%201%20.32%2013.89Zm31.36%2010.855a3.015%203.015%200%200%200-3.015-3.015H3.335a3.015%203.015%200%201%200%200%206.03h25.33a3.015%203.015%200%200%200%203.015-3.015Z%22%20fill%3D%22%23262626%22%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
